// Copyright (c) 2016 Deere & Company

import './general-settings.scss';
import React, {PropTypes} from 'react';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import GeneralSettingsModel from '@deere/cps-it.warranty-model-factory/lib/general-settings';
import Modal from '../../../product/shared/state/modal';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import SettingsHeader from '../../shared/components/settings-header';
import {withRouter} from 'react-router';

let unListen;

function handleUserSettingsSave() {

    this.actions.updateUserSettings();

}

function handleDateFormatChange(dateKey) {

    this.actions.updateGeneralDateFormat(dateKey, this.userGeneralSettings.dateFormat.allowedDateFormats);

}

function handleDecimalFormatChange(decimalKey) {

    this.actions.updateGeneralDecimalFormat(decimalKey, this.userGeneralSettings.decimalFormat.allowedDecimalFormats);

}

function handleTimeZoneFormatChange(timezoneKey) {

    this.actions.updateGeneralTimeZone(timezoneKey, this.userGeneralSettings.timeZone.allowedTimeZones);

}

function handleCsvSeparatorChange(csvSeparator) {

    this.actions.updateCsvSeparator(csvSeparator, this.userGeneralSettings.csvSeparator.allowedCsvSeparators);

}

function handleCloseConfirmationModal() {

    this.actions.closeConfirmSaveModal(this.nextLocation);

}

function handleConfirmSaveModal() {

    this.actions.confirmSaveModal(this.nextLocation);

}

class GeneralSettings extends React.Component {

    componentWillMount() {

        this.props.actions.updateIsSaved(true);

        unListen = this.props.router.listenBefore(nextLocation => this.props.actions.handleOnPageLeave(nextLocation, this.props));

    }

    componentWillUnmount() {

        unListen();

    }

    render() {

        return (
            <section className='general-settings'>
                <SettingsHeader
                    className='general-settings-header'
                    isSaveDisabled={this.props.isSaved}
                    onSave={this.props::handleUserSettingsSave}
                    title='GENERAL'
                />
                <section className='general-settings-panel'>
                    <OptionsDropDown
                        className='date-format'
                        isPlaceholderTranslated={false}
                        label='DATE_FORMAT'
                        onChange={this.props::handleDateFormatChange}
                        optionDisplayAttributes={['value']}
                        optionKey='key'
                        options={this.props.userGeneralSettings.dateFormat.allowedDateFormats}
                        placeholder='SELECT_DATE_FORMAT'
                        selectedValue={this.props.userGeneralSettings.dateFormat.key}
                    />
                    <OptionsDropDown
                        className='decimal-format'
                        isPlaceholderTranslated={false}
                        label='DECIMAL_FORMAT'
                        onChange={this.props::handleDecimalFormatChange}
                        optionDisplayAttributes={['value']}
                        optionKey='key'
                        options={this.props.userGeneralSettings.decimalFormat.allowedDecimalFormats}
                        placeholder='SELECT_DECIMAL_FORMAT'
                        selectedValue={this.props.userGeneralSettings.decimalFormat.key}
                    />
                    <OptionsDropDown
                        className='time-zone'
                        isPlaceholderTranslated={false}
                        label='TIME_ZONE'
                        onChange={this.props::handleTimeZoneFormatChange}
                        optionDisplayAttributes={['value']}
                        optionKey='key'
                        options={this.props.userGeneralSettings.timeZone.allowedTimeZones}
                        placeholder='SELECT_TIME_ZONE'
                        selectedValue={this.props.userGeneralSettings.timeZone.key}
                    />
                    <OptionsDropDown
                        className='csv-separator'
                        isPlaceholderTranslated={false}
                        label='CSV_SEPARATOR'
                        onChange={this.props::handleCsvSeparatorChange}
                        optionDisplayAttributes={['value']}
                        optionKey='key'
                        options={this.props.userGeneralSettings.csvSeparator.allowedCsvSeparators}
                        placeholder='SELECT_CSV_SEPARATOR'
                        selectedValue={this.props.userGeneralSettings.csvSeparator.key}
                    />
                </section>
                <ConfirmationModal
                    confirmMessage='DO_YOU_WANT_TO_SAVE_YOUR_CHANGES'
                    isOpen={this.props.confirmSaveModal.isVisible}
                    onClose={this.props::handleCloseConfirmationModal}
                    onConfirm={this.props::handleConfirmSaveModal}
                    title='SAVE_CHANGES'
                />
            </section>
        );

    }

}

GeneralSettings.displayName = 'GeneralSettings';
GeneralSettings.propTypes = {
    actions: PropTypes.object.isRequired,
    confirmSaveModal: PropTypes.instanceOf(Modal).isRequired,
    isSaved: PropTypes.bool.isRequired,
    nextLocation: PropTypes.string.isRequired,
    router: PropTypes.object.isRequired,
    userGeneralSettings: PropTypes.instanceOf(GeneralSettingsModel).isRequired
};

export default withRouter(GeneralSettings);



// WEBPACK FOOTER //
// ./src/user/general-settings/components/general-settings.js